import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import { Roles } from "./roles";
const Routes_En = () => {
  const Home = lazy(() => import("../../components/home/Home"));
  const PublicDashboard = lazy(() =>
    import("../../components/home/PublicDashboard")
  );


  const PublicLogin = lazy(() => import("../../components/home/PublicLogin"));
  const BilingualSettings = lazy(() =>
    import(
      "../../components/Modules/AdminSettings/Dictionary/DictionaryDashboard"
    )
  );
  const LookUpSettings = lazy(() =>
    import("../../components/Modules/AdminSettings/Lookup/LookUpSettings")
  );
  const StaffDashboard = lazy(() =>
    import("../../components/home/StaffDashboard")
  );



  //Admin settings
  const UserRole_Mapping = lazy(() =>
    import(
      "../Modules/AdminSettings/UserManagement/UserRoleMapping/UserRole_Mapping"
    )
  );

  const AdminRoles = lazy(() =>
    import("../Modules/AdminSettings/AdminRoles/AdminRoles")
  );
  const User = lazy(() => import("../Modules/AdminSettings/User/User"));
  const Application = lazy(() =>
    import("../Modules/AdminSettings/Application/Application.js")
  );
  const UserRoleMatrix = lazy(() =>
    import(
      "../Modules/AdminSettings/UserManagement/RoleResponsbilityMatrix/RoleMatrix"
    )
  );
  const ClassifierSettings = lazy(() =>
    import("../Modules/AdminSettings/Classifier/ClassifierSettings")
  );
  const ExecuteQuery = lazy(() =>
    import("../Modules/AdminSettings/ExecuteQuery/ExecuteQuery")
  );
  const Unauthorized = lazy(() => import("../../components/routing/NoAccess."));
  const NotFound = lazy(() => import("../../components/routing/NotFound"));
  const SiteDetails = lazy(() =>
    import("../Modules/Plantation/addPlantation/ListPlantationSite.js")
  );

  const AddPlantationSite = lazy(() =>
    import("../Modules/Plantation/addPlantation/AddPlantationSite.js")
  );
  const PlantationInspection = lazy(() =>
    import("../Modules/Plantation/PlantationInspection/ListPlantationInspection.js")
  );
  // const PlantationProgress = lazy(() =>
  //   import("../Modules/Plantation/PlantationProgress/ListPlantationProgress.js")
  // );
  const PlantationPlanning = lazy(() =>
    import("../Modules/Plantation/PlantationPlanning/ListPlantationPlanning.js")
  );
  // const ResetPassword = lazy(() => import("../home/ResetPassword"));
  const PMISPrivacyPolicy = lazy(() => import("../home/PMISPrivacyPolicy"));
  const PlantationTarget = lazy(() => import("../../components/Modules/Plantation/PlantationTarget/ListPlantationTarget.js"));
  const Nursery = lazy(() => import("../../components/Modules/Nursery/NurseryInventory/Nursery"));
  const WorkProgress = lazy(() => import("../Modules/Nursery/WorkProgress/WorkProgress"));
  const StockDetails = lazy(() => import("../Modules/Nursery/StockDetails/StockDetails"));
  const ReviewSiteInspection = lazy(() => import("../Modules/Plantation/PlantationInspectionReview/ListPlantationInspectionReview.js"));
  const ContractorKYC_details = lazy(() => import("../Modules/AdminSettings/Contractor_KYC/Contractor_list.js"));
  const ListAgencyRegistration = lazy(() => import("../Modules/AdminSettings/ExternalUser/ListAgencyRegistration.js"));
  const PlantationProgress = lazy(() =>
    import("../Modules/Plantation/PlantationProgress_New/ListPlantationProgress.js")
  );
  const Agency_sites = lazy(() =>
    import("../Modules/Plantation/AgencySites/ListAgency_sites.js")
  );
  const Report = lazy(() =>
    import("../Modules/Plantation/Report/Report.js")
  );
  const UserProfile = lazy(() =>
    import("../Modules/Users/UserProfile")
  );
  const Dashboard = lazy(() =>
    import("../Modules/Dashboard/Dashboard")
  );
  return (
    <Routes>
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL} element={<Home />} />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicDashboard"}
        element={
          <AuthRoute
            requiredRoles={[
              String(Roles.DFO),
              String(Roles.Public),
              String(Roles.DEO),
            ]}
          >
            <PublicDashboard />
          </AuthRoute>
        }
      />
      {/* <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/ResetPassword"} element={<ResetPassword />} /> */}


      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicLogin"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PublicLogin />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <BilingualSettings />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/LookUpSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRole_Mapping />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AdminRoles />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Application />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRoleMatrix"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRoleMatrix />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/User"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <User />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ClassifierSettings />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ExecuteQuery"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ExecuteQuery />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/applicatntInfo"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StaffDashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.DEO)]}>
            <StaffDashboard />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Plantation"}
        element={
          <SiteDetails />
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PlantationProgress"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationProgress />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Report"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Report />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/agency_site"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Agency_sites />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/agency_site/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Agency_sites />
          </AuthRoute>
        }
      />

      {/* <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/PlantationProgress_New"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationProgress_New />
          </AuthRoute>
        }
      /> */}

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AddPlantationtarget"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationTarget />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AddPlantationtarget/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationTarget />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AddPlantationPlanning"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationPlanning />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AddPlantationPlanning/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationPlanning />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AddPlantationSite"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AddPlantationSite />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PlantationInspection"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationInspection />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PMISPrivacyPolicy"} element={<PMISPrivacyPolicy />} />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            < Nursery />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <WorkProgress />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <StockDetails />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/InspectionReview"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ReviewSiteInspection />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ContractorKYC_details"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ContractorKYC_details />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserProfile"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserProfile />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AgencyRegistration"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListAgencyRegistration />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Dashboard />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/InspectionReview/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ReviewSiteInspection />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/as"} element={<Home />} />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicDashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO), String(Roles.Public)]}>
            <PublicDashboard />
          </AuthRoute>
        }
      />

      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AgencyRegistration/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ListAgencyRegistration />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PublicLogin/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PublicLogin />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <BilingualSettings />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/LookUpSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRole_Mapping />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRoleMatrix/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserRoleMatrix />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AdminRoles />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Application />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/User/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <User />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ClassifierSettings />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/applicatntInfo/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <LookUpSettings />
          </AuthRoute>
        }
      />


      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/StaffDashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <StaffDashboard />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Plantation/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <SiteDetails />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/AddPlantationSite/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <AddPlantationSite />
          </AuthRoute>
        }
      />

      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PlantationInspection/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationInspection />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/PlantationProgress/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationProgress />
          </AuthRoute>
        }
      />
      {/* <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL+"/PlantationProgress_New/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <PlantationProgress_New />
          </AuthRoute>
        }
      /> */}
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/ContractorKYC_details/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <ContractorKYC_details />
          </AuthRoute>
        }
      />
      <Route
        exact
        path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserProfile/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <UserProfile />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Report/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Report />
          </AuthRoute>
        }
      />
      <Route exact path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard/as"}
        element={
          <AuthRoute requiredRoles={[String(Roles.DFO)]}>
            <Dashboard />
          </AuthRoute>
        }
      />
      <Route path={globalThis.config.Settings.ApiConfiguration.BaseURL + "/unauthorized"} element={<Unauthorized />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routes_En;
